import React from 'react'
import { Container } from '@material-ui/core'
import styleClasses from '../components/common/common.module.scss'
import ErrorsList from '../components/errors/ErrorsList'

export default function EventsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <ErrorsList />
      </Container>
    </main>
  )
}
